const startEndIndices = (max, pageNum) => {
  let start = max * (pageNum - 1);
  const end = max * pageNum;

  if (pageNum === 1) {
    start = 0;
  }

  return [start, end];
};

const itemsPerPage = (items, max, pageNum) => {
  const [start, end] = startEndIndices(max, pageNum);

  return items.slice(start, end);
};

const numberOfPages = (items, max) => {
  return Math.ceil(items.length / max);
};

export { itemsPerPage, numberOfPages };
